document.addEventListener('click', function (event) {
  var swatch = event.target.closest('.swatch');

  if (swatch) {
    const container = swatch.closest('.product-container');
    const quick_popup_container = container.closest(
      '.quick-view-popup .product-variants-color'
    );
    const quick_popup_atc = quick_popup_container.querySelector(
      '.quick-view-popup-atc'
    );
    if (container) {
      var variants = JSON.parse(container.getAttribute('data-variants'));
      var product_url = container.getAttribute('data-url');
      const swatchContainer = swatch.closest('.swatch-container');
      const swatchList = Array.from(
        swatchContainer.querySelectorAll('.swatch')
      );
      swatchList.forEach((s) => s.classList.remove('active'));
      swatch.classList.add('active');

      var selectedOptions = [];
      var optionContainers = container.querySelectorAll('.swatch-container');

      optionContainers.forEach(function (optionContainer) {
        var activeSwatch = optionContainer.querySelector('.swatch.active');
        if (activeSwatch) {
          selectedOptions.push(activeSwatch.getAttribute('data-value'));
        } else {
          selectedOptions.push(null);
        }
      });

      var selectedVariant = findVariant(variants, selectedOptions);
      if (selectedVariant) {
        container.setAttribute('data-variant-selected', selectedVariant.id);
        quick_popup_atc.setAttribute('data-vid', selectedVariant.id);
        updateSoldOutStates(container, variants, selectedOptions);
        quick_popup_container
          .querySelector('.varaint_block_size')
          .classList.remove('error');
        if (!swatch.classList.contains('soldout_variant')) {
          quick_popup_container.classList.add('enable-add-to-cart');
          quick_popup_container.classList.remove('disabled-add-to-cart');
        } else {
          quick_popup_container.classList.remove('enable-add-to-cart');
          quick_popup_container.classList.add('disabled-add-to-cart');
        }
      }
    }
  }
});

function findVariant(variants, selectedOptions) {
  return variants.find(
    (variant) =>
      variant.option1 == selectedOptions[0] &&
      variant.option2 == selectedOptions[1] &&
      variant.option3 == selectedOptions[2]
  );
}

function updateSoldOutStates(container, variants, selectedOptions) {
  const optionContainers = container.querySelectorAll('.swatch-container');

  optionContainers.forEach(function (optionContainer, index) {
    const swatches = optionContainer.querySelectorAll('.swatch');

    swatches.forEach(function (swatch) {
      const value = swatch.getAttribute('data-value');
      const currentSelectedOptions = [...selectedOptions];
      currentSelectedOptions[index] = value;

      const matchingVariant = findVariant(variants, currentSelectedOptions);
      if (matchingVariant && !matchingVariant.available) {
        swatch.classList.add('soldout_variant');
      } else {
        swatch.classList.remove('soldout_variant');
      }
    });
  });
}

document.addEventListener('click', function (event) {
  const addToCartButton = event.target.closest('.quick-view-popup-atc');

  if (addToCartButton) {
    const quickViewPopup = addToCartButton.closest(
      '.quick-view-popup .product-variants-color'
    );

    let enable_atc;

    if (quickViewPopup.classList.contains('enable-add-to-cart')) {
      enable_atc = true;
    } else {
      const variantBlock = quickViewPopup.querySelector('.varaint_block_size');
      enable_atc = variantBlock ? false : true;
    }

    if (quickViewPopup && enable_atc) {
      const variantId = addToCartButton.getAttribute('data-vid');

      if (variantId) {
        addToCart(variantId);
        document
          .querySelectorAll(
            '.quick-view-popup.active, .quick-view-popup-layer.active'
          )
          .forEach((el) => {
            el.classList.remove('active');
          });
        // document.body.classList.remove('overflow-hidden');
      } else {
        console.error('Variant ID not found on the add to cart button');
      }
    } else {
      quickViewPopup
        .querySelector('.varaint_block_size')
        .classList.add('error');
    }
  }
});

async function addToCart(variantId, quantity = 1) {
  try {
    const cartDrawer = document.querySelector('cart-drawer');

    const formData = {
      items: [{ id: variantId, quantity }],
      sections: cartDrawer ? ['cart-drawer', 'cart-icon-bubble'] : [],
      sections_url: window.location.pathname,
    };

    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(formData),
    });

    const data = await response.json();

    if (data.status) {
      throw new Error(data.message || 'Failed to add item to cart');
    }

    if (cartDrawer) {
      cartDrawer.classList.remove('is-empty');
      const drawerInner = cartDrawer.querySelector('.drawer__inner');
      if (drawerInner) drawerInner.classList.remove('is-empty');

      if (data.item_count === 1) {
        const cartResponse = await fetch(
          `${window.Shopify.routes.root}cart.js`
        );
        const fullCartData = await cartResponse.json();
        data.items = fullCartData.items;
      }

      const renderData = {
        ...data,
        sections: data.sections || {},
        id: variantId,
      };

      cartDrawer.renderContents(renderData);

      setTimeout(() => {
        cartDrawer.open();
      }, 100);
    }

    document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));

    if (window.PUB_SUB_EVENTS) {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'product-form',
        productVariantId: variantId,
        cartData: data,
      });
    }

    return data;
  } catch (error) {
    console.error('Error adding to cart:', error);
    document.dispatchEvent(
      new CustomEvent('cart:error', { detail: error.message })
    );
    throw error;
  }
}

document.addEventListener('click', function (event) {
  const quickViewTrigger = event.target.closest('.quick-view-trigger');
  if (quickViewTrigger) {
    event.preventDefault();
    const drawerId = quickViewTrigger.getAttribute('data-id');
    const drawer = document.getElementById(drawerId);
    const backdrop = document.querySelector(
      `.quick-view-popup-layer[data-id="${drawerId}"]`
    );

    if (drawer && backdrop) {
      if (drawer.parentNode !== document.body) {
        document.body.appendChild(drawer);
      }
      if (backdrop.parentNode !== document.body) {
        document.body.appendChild(backdrop);
      }
      if (quickViewTrigger.classList.contains('upsell-add-to-cart')) {
        drawer.classList.add('quick-view-upsell');
      }
      drawer.offsetHeight;
      drawer.classList.add('active');
      backdrop.classList.add('active');
    }

    return;
  }

  const closeButton = event.target.closest('.quick-view-popup-close-svg');
  if (closeButton) {
    event.preventDefault();

    document
      .querySelectorAll(
        '.quick-view-popup.active, .quick-view-popup-layer.active'
      )
      .forEach((el) => {
        el.classList.remove('active');
      });
    //document.body.classList.remove('overflow-hidden');
    return;
  }

  const BIS_btn = event.target.closest('.back-in-stock-btn');
  if (BIS_btn) {
    document
      .querySelectorAll(
        '.quick-view-popup.active, .quick-view-popup-layer.active'
      )
      .forEach((el) => {
        el.classList.remove('active');
      });
    // document.body.classList.remove('overflow-hidden');
    return;
  }

  const backdropLayer = event.target.closest('.quick-view-popup-layer');
  if (backdropLayer && backdropLayer.classList.contains('active')) {
    event.preventDefault();
    const drawerId = backdropLayer.getAttribute('data-id');
    const drawer = document.getElementById(drawerId);

    if (drawer) {
      drawer.classList.remove('active');
      backdropLayer.classList.remove('active');
      // document.body.classList.remove('overflow-hidden');
    }
    return;
  }
});

document.addEventListener('DOMContentLoaded', function () {
  let currentProduct = null;
  let email = null;

  document.body.addEventListener('click', function (e) {
    const modalOpener = e.target.closest('[data-modal="#Drawer-BackInStock"]');
    if (modalOpener) {
      e.preventDefault();
      currentProduct = {
        handle: modalOpener.dataset.productHandle,
        variants: JSON.parse(modalOpener.dataset.productVariants),
        id: modalOpener.querySelector('button').dataset.productId,
      };
      updateBackInStockModal(currentProduct);
    }
  });

  function updateBackInStockModal(product) {
    const dropdownSelected = document.querySelector('.dropdown-selected p');
    const dropdownOptions = document.querySelector('.dropdown-options');

    dropdownOptions.innerHTML = '';

    if (product.variants.length === 1) {
      dropdownSelected.textContent = product.variants[0].option1;
    } else {
      dropdownSelected.textContent = 'Wähle eine Größe';

      product.variants.forEach((variant) => {
        if (!variant.available) {
          const option = document.createElement('p');
          option.className =
            'back-in-stock-option dropdown-option body-text-sm';
          option.textContent = variant.option1;
          option.dataset.variantId = variant.id;
          dropdownOptions.appendChild(option);
        }
      });
    }

    initDropdown();
  }

  function initDropdown() {
    const dropdownSelected = document.querySelector('.dropdown-selected');
    const dropdownOptions = document.querySelector('.dropdown-options');

    dropdownSelected.addEventListener('click', function () {
      dropdownOptions.style.display =
        dropdownOptions.style.display === 'block' ? 'none' : 'block';
    });

    document.querySelectorAll('.dropdown-option').forEach((option) => {
      option.addEventListener('click', function () {
        dropdownSelected.querySelector('p').textContent = this.textContent;
        dropdownOptions.style.display = 'none';
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.dropdown')) {
        dropdownOptions.style.display = 'none';
      }
    });
  }

  const backInStockAction = document.querySelector('#back-in-stock .notify-me');
  if (backInStockAction) {
    backInStockAction.addEventListener('click', function () {
      const selectedOption = document.querySelector(
        '.dropdown-selected p'
      ).textContent;
      const emailInputWrapper = document.querySelector('#back-in-stock .email');
      const emailInputField = emailInputWrapper.querySelector('input');

      if (!email) {
        emailInputWrapper.classList.add('error');
        emailInputField.classList.add('error');
        return;
      }

      let selectedVariantId = null;
      if (currentProduct.variants.length > 1) {
        const selectedOptionText = document.querySelector(
          '.dropdown-selected p'
        ).textContent;
        const variant = currentProduct.variants.find(
          (v) => v.option1 === selectedOptionText && !v.available
        );
        selectedVariantId = variant?.id;
      } else {
        selectedVariantId = currentProduct.variants[0].id;
      }

      if (!selectedVariantId) {
        console.error('No variant selected or variant not found');
        return;
      }

      emailInputWrapper.classList.remove('error');
      emailInputField.classList.remove('error');
      subscribeToVariantBackInStock(email, selectedVariantId);
    });
  }

  const emailInput = document.querySelector('#back-in-stock .email');
  if (emailInput) {
    emailInput.addEventListener('click', function () {
      this.classList.remove('error');
      this.querySelector('input').classList.remove('error');
    });

    emailInput.addEventListener('change', function (event) {
      email = event.target.value;
    });
  }

  function subscribeToVariantBackInStock(email, variantId) {
    console.log(email, variantId);
    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
              },
            },
          },
          channels: ['EMAIL'],
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${variantId}`,
            },
          },
        },
      },
    };

    var requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-05-15' },
      body: JSON.stringify(payload),
    };

    fetch(
      `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${window.klaviyoCompanyId}`,
      requestOptions
    )
      .then(async (result) => {
        if (result.status == 202) {
          let successMsg = document.querySelector('.success__message');

          if (successMsg) {
            successMsg.style.opacity = 1;
            setTimeout(() => {
              successMsg.style.opacity = 0;
            }, 5000);
          }
        } else {
          let errorMsg = document.querySelector('.error__message');

          if (errorMsg) {
            const response = await result.json();
            const responseErrorMessage = await response.errors[0].detail;

            const defaultMessage = errorMsg.innerText;

            errorMsg.innerText = responseErrorMessage || defaultMessage;
            errorMsg.style.opacity = 1;

            setTimeout(() => {
              errorMsg.style.opacity = 0;
            }, 3000);

            setTimeout(() => {
              errorMsg.innerText = defaultMessage;
            }, 4000);
          }
        }
      })
      .catch((error) => console.log('error: ', error));
  }
});

document.body.addEventListener('click', function (e) {
  const swatch = e.target.closest(
    '.product-variants-color .color-swatch-slider__item'
  );
  // console.log("workig");
  if (!swatch) return;
  e.preventDefault();
  //  console.log("workig2");
  const productId = swatch.getAttribute('data-product-id');
  const popupParent = swatch.closest('.popup-parent');
  if (!popupParent) return;

  const variants = popupParent.querySelectorAll('.product-variants-color');
  variants.forEach((variant) => {
    if (variant.getAttribute('data-id') === productId) {
      variant.style.display = 'block';
    } else {
      variant.style.display = 'none';
    }
  });
});
